<template>
  <div>
    <div class="order-menu" v-if="device !== 'mobile'">
      <emat-block
        :class="{'has-discount': discountAmount}"
        :name="discountAmount ? totalPrice.toString() : total.toString()"
        :discount="totalPrice"
        :order="true"
        :sub-title="btw.toString() + ' incl. BTW'"
        style="margin: 0; width: 203px; position: relative;"
      >

        <delivery-time v-if="deliveryDays !== null" />

        <emat-block-item style="background-color: white; padding: 0 0 15px;">
          <EmatTextarea
            name="input-name"
            v-model="wishes"
          />
          <div style="display: flex;">
            <EmatNumber
              name="input"
              :min="1"
              style="margin-left: 12px;"
              v-model="orderAmount"
            />
            <emat-button
              v-if="this.$store.getters['types/current']"
              type="button"
              bgColor="green"
              class="emat-button"
              @click="openOrderModal = true"
            >
              {{
                this.$store.getters['types/current'].type === 'laadpaal'
                  ? $t('global.word.order_charging_station')
                  : $t('global.word.order_charging_pillar')
              }}
            </emat-button>
          </div>
        </emat-block-item>
      </emat-block>
      <emat-order-summary
        v-if="type"
        :name="'EVhub ' +  type.type + ' ' + configuration.Kleur"
        :options="configuration"
        :products="productSummary"
        :type="type"
        :footer="true" style="width: 203px;"
      >
        <template v-slot:pre-list>
          <span>{{ $t('OrderMenu.warranty') }}</span>
        </template>
        <template v-slot:footer>
          <div style="display: flex; justify-content: center; align-items: center;">
            <template v-if="!method.with_plugs">
              <wcd-svg style="width: 47px; height: auto;"></wcd-svg>
              <span class="text">WCD</span>
            </template>
            <template v-else>
              <img style="width: 47px; height: auto;" v-if="plug" :src="plug.image_url" alt="">
              <span class="text"><strong>{{ plug.name }}</strong>, {{ method.name }} {{ method.extra_name }}</span>
            </template>
          </div>
        </template>
      </emat-order-summary>
    </div>

    <!-- Mobile menu -->
    <div class="mobile-menu" v-if="device === 'mobile'">
      <div class="info-banner" @click="confirmLeave">
        <div class="info-title-wrapper">
          <img :src="asset('/assets/images/icons/triangle-light-blue.svg')" class="chevron-left icon">
          <p>
            {{ $t('OrderMenu.close_and_go_to') }}<span>Elektramat</span>
          </p>
        </div>
      </div>
      <div class="mobile-order-menu">
        <emat-block-dropdown
          name=""
          :dropdown-title="this.$t('OrderMenu.best_power') + carName + '?'"
          icon="car"
          @previous="$emit('previous')"
          class="mobile-dropdown"
          :drop="false">
        </emat-block-dropdown>
        <emat-block-dropdown
          name=""
          :dropdown-title="$t('OrderMenu.best_power') + carName"
          :inner-text="$t('OrderMenu.best_charging_times')"
          icon="cogwheel"
          class="mobile-dropdown"
          :class="{'disabled': !model}"
          :drop="!!model">
          <template v-slot:right-content>
            <div class="table" v-if="model">
              <div class="header">
                <span></span>
                <span class="heading">{{ $t('global.label.power') }}</span>
                <span class="heading">{{ $t('ChargeTimes.charging_time_100') }}</span>
              </div>
              <div class="content">
                <div class="row" v-for="(value, i) in chargeTimes" :key="i">
                  <span class="col"><img :src="asset('/assets/images/icons/battery.svg')" alt=""></span>
                  <span class="col">{{ value.power }} kW</span>
                  <span class="col">{{ formatTime(value.time) }} <span class="duplicate" v-if="value.duplicate">*</span></span>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:left-title>{{ plug.name }} {{ $t('global.word.plug') }}</template>
          <template v-slot:left-content>
            <p class="text">{{ $t('ChargeTimes.plug_is_used', { plug: plug.name.toLowerCase() }) }} {{ carName }}</p>
            <img style="height: 90px; margin-top: 10px; filter: grayscale(1) contrast(250%);" v-if="plug"
                 :src="plug.image_url" alt="">
          </template>
        </emat-block-dropdown>
        <emat-block
          :name="total.toString().replace('.', ',')"
          :is-mobile-order="true"
          :sub-title="btw.toString() + ' incl. BTW'"
          style="align-items: center; margin: 0; width: 100%; display: flex; flex-wrap: nowrap; justify-content: space-between"
          :device="device"
        >
          <EmatButton
            type="button"
            bgColor="green"
            style="width: 48px; height: 50px; margin-right: 5px;"
            :show-icon="true"
            @click="openOrderModal = true"
          />
        </emat-block>
      </div>
    </div>

    <OrderPopup
      v-if="openOrderModal"
      :menu="openOrderModal"
      :price="total"
      :btw="btw"
      @close="openOrderModal = false"
    />
  </div>
</template>

<script>
import WcdSvg from 'Components/../assets/icons/wcd.svg?inline';

import EmatBlock from 'Components/Layout/Block';
import EmatBlockItem from 'Components/Layout/BlockItem';
import EmatOrderAction from 'Components/Layout/OrderAction';
import EmatTextarea from 'Components/Inputs/Textarea';
import EmatNumber from 'Components/Inputs/Number';
import EmatButton from 'Components/General/Button';
import EmatOrderSummary from 'Components/Layout/OrderSummary';
import OrderPopup from './OrderPopup';
import EmatBlockDropdown from 'Components/Layout/BlockDropdown';

import { mapGetters } from 'vuex';
import DeliveryTime from '@/components/order/DeliveryTime';
import helpers from '@/mixins/helpers';

export default {
  name: 'OrderMenu',

  mixins: [helpers],

  data() {
    return {
      totalProductDiscount: 0,
    };
  },

  components: {
    DeliveryTime,
    EmatBlock,
    EmatBlockItem,
    EmatOrderAction,
    EmatTextarea,
    EmatNumber,
    EmatButton,
    EmatOrderSummary,
    OrderPopup,
    EmatBlockDropdown,
    WcdSvg,
  },

  computed: {
    ...mapGetters({
      type: 'types/current',
      method: 'methods/current',
      plug: 'methods/currentPlug',
      configuration: 'build/getConfigurationSummary',
      prices: 'build/getConfigurationPrices',
      productPrices: 'products/getPrices',
      products: 'products/getAll',
      productSummary: 'products/getProductSummary',
      device: 'getDevice',
      brand: 'build/getBrand',
      model: 'build/getModel',
    }),
    ...mapGetters('build', [
      'deliveryDays',
    ]),

    total() {
      let sum = 0;

      for (let el in this.prices) {
        if (this.prices.hasOwnProperty(el)) {
          if (!this.prices[el]) {
            continue;
          }

          sum += parseFloat(this.prices[el]);
        }
      }

      return (sum + this.totalProductPrice).toFixed(2);
    },
    totalProductPrice() {
      let productDiscount = this.products
        .filter(product => {
          return product.magento_category_id !== null && this.hasDiscount(product.magento_category_id);
        })
        .map((product) => {
          return {
            product_id: product.magento_category_id,
            discount: this.getDiscount(product.magento_category_id),
          };
        });

      let totalProductDiscount = 0;
      let totalProductPrice = this.products.reduce((total, add) => {
        var percentage = productDiscount.find(function(e) {
          return e.product_id === add.magento_category_id;
        });
        if (productDiscount.some(i => i.product_id === add.magento_category_id)) {
          let discount = percentage.discount;
          let price = (add.price * discount) / 100;
          totalProductDiscount += (price * add.amount);
          return total + (add.price * add.amount);
        } else {
          return total + (add.price * add.amount);
        }
      }, 0);
      this.totalProductDiscount = totalProductDiscount;

      return totalProductPrice;
    },
    discountPercentage() {
      if (this.type && this.hasDiscount(this.type.magento_category_id)) {
        return this.getDiscount(this.type.magento_category_id);
      } else if (this.type && this.hasDiscount(3983)) {
        return this.getDiscount(3983);
      }
    },
    discountAmount() {
      let total = this.total * (this.discountPercentage / 100);
      let product = this.totalProductDiscount;
      if (!isNaN(total) && product === 0) {
        return total;
      } else if (isNaN(total) && product !== 0) {
        return product;
      } else {
        return total + product;
      }
    },
    totalPrice() {
      if (this.type && this.hasDiscount(this.type.magento_category_id)) {
        let discountPercentage = this.getDiscount(this.type.magento_category_id);
        let discountPrice = (this.total * discountPercentage) / 100;
        return (this.total - discountPrice).toFixed(2);
      } else if (this.type && this.hasDiscount(3983)) {
        let discountPercentage = this.getDiscount(3983);
        let discountPrice = (this.total * discountPercentage) / 100;
        return (this.total - discountPrice).toFixed(2);
      } else if (this.totalProductDiscount !== 0) {
        return (+this.total - this.totalProductDiscount);
      }

      return this.total;
    },
    btw() {
      return (this.totalPrice * 1.21).toFixed(2);
    },
    chargeTimes() {
      // Format charge times from Object to Array
      const chargeTimes = Object.keys(this.model.charge_times).map(key => {
        return { power: Number(key), time: this.model.charge_times[key] };
      }).filter(time => time.power === 2.3 || time.power === 7.4 || time.power === 11 || time.power === 22);

      // Sort charge times by power ASC
      chargeTimes.sort(function(a, b) {
        if (a.power < b.power) { return -1; }
        if (a.power > b.power) { return 1; }
        return 0;
      });

      // Check for duplicate times
      let tempArray = [];
      chargeTimes.map(chargeTime => {
        if (tempArray.find(x => x === chargeTime.time)) {
          this.hasDuplicates = true;
          chargeTime.duplicate = true;
        } else {
          tempArray.push(chargeTime.time);
        }
      });
      tempArray = [];

      return chargeTimes;
    },
    carName() {
      let name = '';

      if (this.brand) name += this.brand.name + ' ';
      if (this.model) name += this.model.name;

      return name;
    },
    openOrderModal: {
      get() {
        return this.$store.getters.getOrderModal;
      },
      set(value) {
        this.$store.commit('setOrderModal', value);
      },
    },
    orderAmount: {
      get() {
        return this.$store.getters['order/getOrderAmount'];
      },
      set(value) {
        this.$store.dispatch('order/changeOrderAmount', value);
      },
    },
    wishes: {
      get() {
        return this.$store.getters['build/getWishes'];
      },
      set(value) {
        this.$store.dispatch('build/changeWishes', value);
      },
    },
    totalBTW() {
      return this.totalPrice * 1.21;
    },
  },

  methods: {
    formatTime(val) {
      let hours = Math.floor(val / 60);
      let minutes = val % 60;
      return hours + 'h ' + minutes + 'm';
    },
    hasDiscount(item) {
      return (this.$store.state.discounts.hasOwnProperty(item));
    },
    getDiscount(item) {
      if (this.hasDiscount(item)) {
        return this.$store.state.discounts[item];
      }
    },
    confirmLeave() {
      if (window.confirm(this.$t('OrderMenu.confirm_leave'))) {
        window.location.href = 'https://www.elektramat.nl/';
      }
    },
  },
};
</script>

<style scoped lang="scss">
.order-menu {
  padding: 6px;

  .total-btw {
    text-align: left;
  }
}

.emat-button {
  margin-left: 6px;
  width: 121px;
  line-height: 16px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;

  @media only screen and (max-width: 576px) {
    padding-right: 0;
    padding-left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.mobile-menu {
  .mobile-dropdown {
    border-right: 1px solid $primary-lighter;
    height: 60px;
    width: 60px;
  }

  .info-banner {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 36px;
    top: 0;
    left: 0;
    right: 0;
    z-index: 3;
    background-color: $highlight;

    .info-title-wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      padding-left: 17px;
      padding-right: 17px;
      font-family: $font;
      font-size: 12px;

      p {
        margin: 0;
      }

      img {
        margin-right: 8px;
        transform: rotate(90deg);
      }

      span {
        color: $primary-lighter;
        font-family: $font-black;
      }
    }
  }

  .mobile-order-menu {
    position: fixed;
    top: 36px;
    right: 0;
    left: 0;
    height: 60px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, .1);
    background: #fff;
    display: flex;
    z-index: 2;
    margin-left: auto;
    flex-shrink: 1;
    flex-grow: 1;
  }
}
</style>
